import { TreeViewResponseItem } from "@/apis/preview/v2/types";
import { AxisSumToggle } from "../tree/axis-item";
import { DepthIcon } from "../tree/depth-icon";
import { ContainerHeader } from "./container-header";
import { CustomContainer } from "./type";

const SumToggleArea = ({
  isDragging,
  dimension,
  container,
}: {
  isDragging?: boolean;
  dimension: "LINE_ITEM" | "AXIS" | "TEXTBLOCK";
  container: CustomContainer;
}) => {
  const firstMember = container.headerShownItems.find(
    (item) => item.tagType === "MEMBER",
  );
  console.log(container);
  if (!firstMember?.tagKey) return null;

  return (
    !isDragging &&
    dimension === "AXIS" && (
      <div className="px-[16px]">
        <AxisSumToggle
          memberTagKey={firstMember.tagKey}
          roleKey={container.roleKey}
        />
      </div>
    )
  );
};

const TagGroupContainer = ({
  dimension,
  container,
  children,
  handleProps,
  isDragging,
  selectedId,
  onItemClick,
  onItemHoverStart,
  onItemHoverEnd,
  getTaggedCellCount,
  onItemRemove,
  tagDetailRoleKey,
}: {
  container: CustomContainer;
  children: React.ReactNode;
  dimension: "LINE_ITEM" | "AXIS" | "TEXTBLOCK";
  handleProps?: {
    attributes: Record<string, any>;
    listeners: Record<string, any> | undefined;
  };
  isDragging?: boolean;
  selectedId?: string | null;
  onItemClick?: (tagKey: string, tagKoLabel: string) => void;
  onItemHoverStart?: (tagKey: string, tagKoLabel: string) => void;
  onItemHoverEnd?: () => void;
  getTaggedCellCount?: (tagKey: string) => number;
  onItemRemove?: (item: TreeViewResponseItem, cellCount: number) => void;
  tagDetailRoleKey?: string;
}) => {
  return (
    <>
      <SumToggleArea
        isDragging={isDragging}
        dimension={dimension}
        container={container}
      />
      <div className="flex flex-col p-[16px] py-[12px]">
        <ContainerHeader
          treeViewItems={container.headerShownItems}
          roleKey={container.roleKey}
          selectedId={selectedId}
          onItemClick={onItemClick}
          onItemHoverStart={onItemHoverStart}
          onItemHoverEnd={onItemHoverEnd}
          getTaggedCellCount={getTaggedCellCount}
          onItemRemove={onItemRemove}
          tagDetailRoleKey={tagDetailRoleKey}
          {...handleProps}
        />
        {isDragging ? null : (
          <div className="flex flex-row w-full">
            <div className="flex flex-row pl-[12px]">
              <DepthIcon />
            </div>
            <div className="flex flex-col border rounded-md bg-white border-[#E2E8F0] p-[12px] pt-[16px] w-[408px] overflow-hidden mt-[12px]">
              {children}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default TagGroupContainer;
